/* global SWDLocalise */
import lottie from 'lottie-web';

const init = () => {
    const container = document.querySelector('.js-404-animation');
    if (!container) return;

    lottie.loadAnimation({
        container,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: `${SWDLocalise.mediaUrl}/js/components/error-page/animation.json`,
    });
};

export default init;
